import { FormikInput } from '../FormikInput'
import { Select } from '../Select'
import { EquipmentSelector } from '../EquipmentSelector'
import { WrapperFormRowStyled } from './style'
import { useFormikContext, getIn } from 'formik'

export interface IPropsData {
    value?: string | number
    name: string
    label?: string
    placeholder?: string
    disabled?: boolean
    type: 'text' | 'email' | 'password' | 'number' | string
    required?: boolean
    maskConfig?: any
    hidden?: boolean
    component?: React.ComponentType<any>
    render?: () => React.ReactNode
}

interface IPropsSelectValues {
    name: string
    id: number
}

interface IPropsWrapperFormRow {
    title?: string
    formData: Array<Array<IPropsData>>
    children?: React.ReactNode
    selectValues?: IPropsSelectValues[]
}

export const WrapperFormRow = ({
    title,
    formData,
    children,
    selectValues,
}: IPropsWrapperFormRow) => {
    const { setFieldValue, values } = useFormikContext<any>()

    return (
        <WrapperFormRowStyled>
            {title && <div className='title'>{title}</div>}
            <div className='container'>
                {formData.map((dataRow, index) => (
                    <div className='row' key={index}>
                        {dataRow.map((item, itemIndex) => {
                            if (item.type === 'select' && !item.disabled) {
                                return (
                                    selectValues && (
                                        <Select
                                            name={item.name}
                                            label={item.label || 'Выберите'}
                                            key={itemIndex}
                                            onChange={value =>
                                                setFieldValue(item.name, value)
                                            }
                                            value={getIn(values, item.name)}
                                            required={item.required}
                                            placeholder={
                                                item.placeholder || 'Выберите'
                                            }
                                            options={selectValues?.map(
                                                selectItem => ({
                                                    title: selectItem.name,
                                                    value: selectItem.id,
                                                }),
                                            )}
                                        />
                                    )
                                )
                            }

                            if (item.type === 'equipment') {
                                return (
                                    <EquipmentSelector
                                        key={itemIndex}
                                        label={item.label}
                                        placeholder={item.placeholder}
                                        required={item.required}
                                        disabled={item.disabled}
                                        value={getIn(values, item.name) || []}
                                        onChange={value =>
                                            setFieldValue(item.name, value)
                                        }
                                    />
                                )
                            }

                            if (item.type === 'custom' && item.render) {
                                return item.render()
                            }

                            return (
                                <>
                                    {item.hidden !== true && (
                                        <FormikInput
                                            required={item.required}
                                            key={itemIndex}
                                            name={item.name}
                                            label={item.label}
                                            placeholder={item.placeholder}
                                            type={item.type}
                                            disabled={item.disabled ?? false}
                                            value={values[item.name]}
                                            maskConfig={item.maskConfig}
                                            className='inputForm'
                                            $afterIcon='clearInput'
                                        />
                                    )}
                                </>
                            )
                        })}
                    </div>
                ))}
                {children}
            </div>
        </WrapperFormRowStyled>
    )
}
